(() => {
  const root=document.documentElement;
  const pointerClass='orli-pointer-input';
  const navigationKeys=new Set(['Tab','Enter',' ','Escape','ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End','PageUp','PageDown']);
  const clearPointerInput=()=>root.classList.remove(pointerClass);
  document.addEventListener('pointerdown',()=>root.classList.add(pointerClass),{capture:true,passive:true});
  document.addEventListener('keydown',event=>{if(navigationKeys.has(event.key))clearPointerInput();},true);
  window.addEventListener('blur',clearPointerInput);
  window.addEventListener('pagehide',clearPointerInput);
  const menus=[...document.querySelectorAll('mobile-menu')];
  if(!menus.length)return;
  customElements.whenDefined('mobile-sliderule').then(()=>{
    const prototype=customElements.get('mobile-sliderule').prototype;
    const original=prototype.adjustMenuHeight;
    prototype.adjustMenuHeight=function(){
      if(!this.closest('mobile-menu')||!this.menuBlock)return original.call(this);
      const panel=this.menuBlock.querySelector('[data-sliderule="2"].is-visible')||this.menuBlock.querySelector('[data-sliderule="1"].is-visible')||this.menuBlock;
      const links=panel.querySelector('[data-links]');
      if(!links)return;
      const offset=links.getBoundingClientRect().top-this.menuBlock.getBoundingClientRect().top;
      const padding=parseFloat(getComputedStyle(this.menuBlock).paddingBottom)||0;
      this.menuBlock.style.setProperty('--block-height',`${Math.ceil(links.scrollHeight+offset+padding)}px`);
    };
    let frame;
    const resize=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>menus.forEach(menu=>menu.querySelector('mobile-sliderule')?.adjustMenuHeight()));};
    window.addEventListener('resize',resize,{passive:true});
    document.fonts?.ready.then(resize);
    resize();
  });
  customElements.whenDefined('header-search-popdown').then(()=>{
    document.querySelectorAll('header-search-popdown').forEach(search=>{
      search.addEventListener('keyup',event=>{
        if(event.code!=='Escape'||!search.classList.contains('is-open'))return;
        event.stopImmediatePropagation();search.close();
      },true);
      search.querySelector('[data-popdown]')?.addEventListener('transitionend',event=>{
        if(event.target!==search.querySelector('[data-popdown]')||event.propertyName!=='opacity'||search.classList.contains('is-open'))return;
        const summary=search.querySelector('summary');
        const drawer=search.closest('header-drawer.is-open');
        if(drawer&&window.theme?.a11y){window.theme.a11y.trapFocus(drawer.querySelector('[data-drawer-inner]'),{elementToFocus:summary});}
        else if(!search.closest('mobile-menu'))summary?.focus({preventScroll:true});
      });
    });
  });
})();

(() => {
  const selector='.product-item__image';
  const properties=['top','right','bottom','left','width','max-width','max-height','overflow','justify-content'];
  const areas=new Set(),pending=new Set(),original=new WeakMap(),signatures=new WeakMap();
  let frame=0;
  function photoBounds(rect,naturalWidth,naturalHeight,fit,position='50% 50%'){
    if(!(rect.width>0&&rect.height>0&&naturalWidth>0&&naturalHeight>0))return null;
    if(fit!=='contain'&&fit!=='scale-down'&&fit!=='none')return {left:rect.left,top:rect.top,right:rect.right,bottom:rect.bottom,width:rect.width,height:rect.height};
    const scale=fit==='none'?1:Math.min(rect.width/naturalWidth,rect.height/naturalHeight,fit==='scale-down'?1:Infinity);
    const width=naturalWidth*scale,height=naturalHeight*scale;
    const parts=position.trim().split(/\s+/);
    const offset=(value,space)=>value?.endsWith('%')?space*parseFloat(value)/100:value?.endsWith('px')?parseFloat(value):space/2;
    const left=rect.left+offset(parts[0],rect.width-width),top=rect.top+offset(parts[1],rect.height-height);
    const clippedLeft=Math.max(rect.left,left),clippedTop=Math.max(rect.top,top);
    return {left:clippedLeft,top:clippedTop,right:Math.min(rect.right,left+width),bottom:Math.min(rect.bottom,top+height),width:Math.max(0,Math.min(rect.right,left+width)-clippedLeft),height:Math.max(0,Math.min(rect.bottom,top+height)-clippedTop)};
  }
  function measure(area){
    const badges=area.querySelector('.badge-box-container');
    if(!badges?.children.length)return null;
    const outer=area.getBoundingClientRect();
    if(!(outer.width>0&&outer.height>0))return {badges};
    for(const image of [...area.querySelectorAll('img')].reverse()){
      const rect=image.getBoundingClientRect();
      if(!(rect.width>0&&rect.height>0&&image.naturalWidth>0&&image.naturalHeight>0))continue;
      if(rect.left>outer.left+outer.width/2||rect.right<outer.left+outer.width/2||rect.top>outer.top+outer.height/2||rect.bottom<outer.top+outer.height/2)continue;
      let visible=true;
      for(let node=image;node&&node!==area;node=node.parentElement){
        const style=getComputedStyle(node);
        if(style.display==='none'||style.visibility==='hidden'||Number(style.opacity)===0){visible=false;break;}
      }
      if(!visible)continue;
      const style=getComputedStyle(image),paint=photoBounds(rect,image.naturalWidth,image.naturalHeight,style.objectFit,style.objectPosition);
      if(!paint)continue;
      const left=Math.max(outer.left,paint.left),top=Math.max(outer.top,paint.top);
      const right=Math.min(outer.right,paint.right),bottom=Math.min(outer.bottom,paint.bottom);
      if(right<=left||bottom<=top)continue;
      const isBottom=/align--bottom-/.test(badges.className),isRight=/align--(?:top|bottom)-right/.test(badges.className),isCenter=/align--(?:top|bottom)-center/.test(badges.className);
      const px=value=>Math.max(0,value).toFixed(3)+'px';
      return {badges,values:{
        top:isBottom?'auto':px(top-outer.top),bottom:isBottom?px(outer.bottom-bottom):'auto',
        left:isRight?'auto':px(left-outer.left),right:isRight?px(outer.right-right):'auto',
        width:isCenter?px(right-left):'auto','max-width':px(right-left),'max-height':px(bottom-top),
        overflow:'hidden','justify-content':isCenter?'center':isRight?'flex-end':'flex-start'
      }};
    }
    return {badges};
  }
  function apply(result){
    if(!result?.badges)return;
    const {badges,values}=result,signature=JSON.stringify(values||null);
    if(signatures.get(badges)===signature)return;
    if(values){
      if(!original.has(badges))original.set(badges,properties.map(name=>[name,badges.style.getPropertyValue(name),badges.style.getPropertyPriority(name)]));
      for(const [name,value] of Object.entries(values))badges.style.setProperty(name,value);
    }else if(original.has(badges)){
      for(const [name,value,priority] of original.get(badges))value?badges.style.setProperty(name,value,priority):badges.style.removeProperty(name);
    }
    signatures.set(badges,signature);
  }
  function queue(area){
    if(!area?.isConnected||!areas.has(area))return;
    pending.add(area);
    if(!frame)frame=requestAnimationFrame(()=>{
      frame=0;
      const results=[...pending].map(item=>{try{return measure(item);}catch{return null;}});
      pending.clear();
      results.forEach(apply);
    });
  }
  const resize=typeof ResizeObserver==='function'?new ResizeObserver(entries=>entries.forEach(entry=>queue(entry.target))):null;
  const images=new MutationObserver(records=>records.forEach(record=>{
    if(!record.target.closest?.('.badge-box-container'))queue(record.target.closest?.(selector));
  }));
  const queueEvent=event=>queue(event.currentTarget.closest(selector));
  function observe(area){
    if(areas.has(area)||!area.querySelector('.badge-box-container')?.children.length)return;
    areas.add(area);
    images.observe(area,{subtree:true,attributes:true,attributeFilter:['class','style','src','srcset','sizes']});
    resize?.observe(area);
    for(const name of ['load','error','pointerenter','pointerleave','focusin','focusout','transitionend','animationend'])area.addEventListener(name,queueEvent,true);
    const slider=area.querySelector('[data-hover-slider]');
    slider?.addEventListener('scroll',queueEvent,true);
    queue(area);
  }
  function scan(node,callback){
    if(node.nodeType!==1)return;
    if(node.matches(selector))callback(node);
    node.querySelectorAll(selector).forEach(callback);
  }
  function start(){
    document.querySelectorAll(selector).forEach(observe);
    const structure=new MutationObserver(records=>{
      let removed=false;
      for(const record of records){
        for(const node of record.addedNodes)scan(node,observe);
        const area=record.target.closest?.(selector);
        if(area)observe(area);
        queue(area);
        for(const node of record.removedNodes)scan(node,area=>{
          if(area.isConnected||!areas.delete(area))return;
          removed=true;pending.delete(area);resize?.unobserve(area);
          for(const name of ['load','error','pointerenter','pointerleave','focusin','focusout','transitionend','animationend'])area.removeEventListener(name,queueEvent,true);
          area.querySelector('[data-hover-slider]')?.removeEventListener('scroll',queueEvent,true);
        });
      }
      if(removed){images.disconnect();areas.forEach(area=>images.observe(area,{subtree:true,attributes:true,attributeFilter:['class','style','src','srcset','sizes']}));}
    });
    document.querySelectorAll('#MainContent,predictive-search,[data-popular-searches],recently-viewed').forEach(root=>structure.observe(root,{subtree:true,childList:true}));
    window.addEventListener('resize',()=>areas.forEach(queue),{passive:true});
    document.fonts?.ready.then(()=>areas.forEach(queue));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

